<template>
    <div id="novel_generator">
        <top :topIndex="4"></top>
        <div class="mian" :style="{ height: mianH + 'px' }">
            <div class="de-ai-rate">
                <!-- 顶部区域 -->
                <div class="top-bar">
                    <!-- 左侧：标题 + 选择器一排 -->
                    <div class="top-left">
                       
                        <div style="display: flex;align-items: center; ">
                             <h1 class="title">AI降痕神器</h1>
                           <div class="history-wrap" @click="handleHistory">
                              历史记录
                            </div>
                        </div>

                        <div class="selectors-inline">
                            <!-- 稿件类型 -->
                            <div class="selector-inline">
                                <span class="selector-label">稿件类型</span>
                                <span
                                    v-for="item in articleTypes"
                                    :key="item.label"
                                    class="chip"
                                    :class="{ active: formData.articleType === item.label }"
                                    @click="formData.articleType = item.label"
                                >{{ item.label }}</span>
                            </div>

                            <!-- 消痕版本 -->
                            <div class="selector-inline">
                                <span class="selector-label">消痕版本</span>
                                <span
                                    v-for="v in versionList"
                                    :key="v.key"
                                    class="chip"
                                    :class="{ active: formData.version === v.key }"
                                    @click="formData.version = v.key"
                                >{{ v.label }}</span>
                            </div>

                            <!-- 改写强度 -->
                            <div class="selector-inline">
                                <span class="selector-label">改写强度</span>
                                <span
                                    v-for="item in intensityList"
                                    :key="item.key"
                                    class="chip"
                                    :class="{ active: formData.intensity === item.key }"
                                    @click="formData.intensity = item.key"
                                >{{ item.label }}</span>
                            </div>
                        </div>
                    </div>

                    <!-- 右侧：历史记录 -->
                 
                </div>

                <!-- 主体内容：左右分栏 -->
                <div class="main-content">
                    <!-- ============ 左侧 ============ -->
                    <div class="content-panel">
                        <div class="panel-header">
                            <div class="panel-header-left">
                                <i class="el-icon-document"></i>
                                <span>{{ hasResult ? '原文对比' : '原文输入' }}</span>
                            </div>
                            <div class="panel-header-right">
                                <template v-if="!hasResult">
                                    <el-button size="small" icon="el-icon-upload2" :loading="uploading" @click="handleUpload">{{ uploading ? '上传中' : '上传' }}</el-button>
                                </template>
                                <el-button size="small" icon="el-icon-delete" @click="handleClear">清空</el-button>
                            </div>
                        </div>

                        <!-- 有结果时：显示原文 diff 对比 -->
                        <div v-if="hasResult" class="editor-area diff-area diff-left" ref="leftScroll">
                            <div class="diff-legend-bar">
                                <span class="legend-item"><span class="legend-del"></span>删除内容</span>
                            </div>
                            <div class="diff-content" v-html="compareOriginalHtml()"></div>
                        </div>

                        <!-- 无结果时：显示输入框 -->
                        <div v-else class="editor-area">
                            <textarea
                                class="text-input"
                                v-model="originalContent"
                                placeholder="请输入正文内容或上传 txt/docx 文件"
                            ></textarea>
                        </div>

                        <div class="editor-footer">
                            <div class="word-count">
                                原文字数 <b>{{ originalTextLength }}</b> / 10000
                            </div>
                            <el-button
                                type="primary"
                                :loading="processing"
                                class="start-btn"
                                @click="handleProcess"
                            >
                                <i class="el-icon-video-play" style="margin-right: 4px"></i>
                                {{ processing ? '处理中...' : '提交' }}
                            </el-button>
                        </div>
                    </div>

                    <!-- ============ 右侧 ============ -->
                    <div class="content-panel">
                        <div class="panel-header">
                            <div class="panel-header-left">
                                <span>消痕后内容</span>
                                <i v-if="streamStatus" class="el-icon-loading" style="color: #4a8cff; margin-left: 6px;"></i>
                            </div>
                            <div class="panel-header-right">
                                <span v-if="hasResult && !streamStatus" class="result-count">结果字数 {{ resultTextLength }}</span>
                            </div>
                        </div>

                        <div class="editor-area result-area" ref="resultScroll" style="position: relative;">
                            <!-- 流式生成中 -->
                            <div v-if="streamStatus" class="stream-area">
                                <div v-if="!streamText || streamWaiting" class="stream-loading">
                                    <i class="el-icon-loading"></i>
                                    <span>正在深度消痕，请耐心等待...</span>
                                </div>
                                <div v-else class="stream-text" v-html="markedStreamText"></div>
                                <div class="stream-stop-btn" @click="stopStream">
                                    <i class="el-icon-video-pause"></i>
                                    <span>停止生成</span>
                                </div>
                            </div>

                            <!-- 对比数据加载中 -->
                            <div v-else-if="compareLoading" class="compare-loading">
                                <i class="el-icon-loading"></i>
                                <span>正在生成对比结果...</span>
                            </div>

                            <!-- 有结果时：显示 diff 对比 -->
                            <div v-else-if="hasResult" class="diff-area diff-right">
                                <div class="diff-legend-bar">
                                    <span class="legend-item"><span class="legend-add"></span>新增内容</span>
                                </div>
                                <div class="diff-content" v-html="compareResultHtml()"></div>
                            </div>

                            <!-- 无结果时：占位提示 -->
                            <div v-else class="empty-placeholder">
                                <i class="el-icon-magic-stick"></i>
                                <span>点击「开始」生成消痕结果</span>
                            </div>
                        </div>

                        <div v-if="hasResult && !streamStatus" class="result-actions">
                            <el-button size="small" icon="el-icon-document-copy" @click="handleCopy">复制</el-button>
                            <el-button size="small" icon="el-icon-download" @click="handleDownload('txt')">下载 TXT</el-button>
                            <el-button size="small" icon="el-icon-download" @click="handleDownload('word')">下载 Word</el-button>
                             <el-button size="small" icon="el-icon-download" @click="handleTrage()">朱雀检测</el-button>
                        
                        </div>
                    </div>
                </div>

                <!-- 隐藏的文件上传 -->
                <input
                    ref="fileInput"
                    type="file"
                    accept=".txt,.doc,.docx"
                    style="display: none"
                    @change="onFileChange"
                />
            </div>
        </div>
        <vipPopup></vipPopup>
    </div>
</template>

<script>
import top from '../components/top.vue'
import vipPopup from '@/components/vip_popup.vue' //vip页面
import mammoth from 'mammoth'
import api from '@/api/api'
import { EventBus } from '@/utils/eventBus'
import { marked } from 'marked'

export default {
    components: {
        top,
        vipPopup
    },
    data() {
        return {
            mianH: 0,
            formData: {
                articleType: '',       // 默认不选中
                version: '',           // 默认不选中
                intensity: null        // 默认不选中
            },
            // 稿件类型：label 做选中标识，type 做接口提交
            articleTypes: [
                { label: '小说', type: 'novel' },
                { label: '剧本', type: 'script' },
                { label: '公众号', type: 'media' },
                { label: '头条', type: 'media' },
                { label: '小红书', type: 'media' }
            ],
            // 消痕版本：v2偏向低AI率 v3偏向自然表达
            versionList: [
              { label: '真人自然感', key: 'v4.0' },
				{ label: '偏向低AI率', key: 'v3.3' },
				{ label: '偏向自然表达', key: 'v3.2' }
            ],
            // 改写强度：1极低 2低 3中 4高 5极高
            intensityList: [
                { label: '极低', key: 1 },
                { label: '低', key: 2 },
                { label: '中', key: 3 },
                { label: '高', key: 4 },
                { label: '极高', key: 5 }
            ],
            originalContent: '',
            resultContent: '',
            processing: false,
            uploading: false,
            cost: 5,
            // 流式生成相关
            streamIndex: 0,
            debounceTimer: null,
            typingTimer: null,
            streamStatus: false,
            isStop: false,
            streamText: '',
            markedStreamText: '',
            streamWaiting: false, // 轮询返回空数据（后端仍在生成下一段）时的等待状态
            // 对比相关
            logId: '',
            compareData: null,
            hasResult: false,       // 是否有消痕结果（控制左侧输入框/对比的切换）
            compareLoading: false   // 对比数据加载中（流式结束→对比显示的过渡）
        }
    },
    computed: {
        handleTrage(){
            window.open("https://matrix.tencent.com/ai-detect/ai_gen", '_blank')
        },
        inputEditorOptions() {
            return {
                theme: 'snow',
                modules: { toolbar: false },
                placeholder: '请输入正文内容或上传 txt/doc 文件'
            }
        },
        originalTextLength() {
            return this.stripHtml(this.originalContent).length
        },
        resultTextLength() {
            return this.stripHtml(this.resultContent).length
        },
        submitParams() {
            const typeItem = this.articleTypes.find(
                item => item.label === this.formData.articleType
            )
            return {
                type: typeItem ? typeItem.type : 'media',
                level: this.formData.intensity,
                version: this.formData.version,
                text: this.stripHtml(this.originalContent)
            }
        }
    },
    mounted() {
        this.calculateMianHeight();
        window.addEventListener('resize', this.calculateMianHeight);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.calculateMianHeight);
        this.clearTimer();
    },
    methods: {
        stripHtml(html) {
            const tmp = document.createElement('div')
            tmp.innerHTML = html || ''
            return (tmp.textContent || tmp.innerText || '').replace(/\u200B/g, '')
        },
        escapeHtml(text) {
            const div = document.createElement('div');
            div.textContent = text;
            return div.innerHTML;
        },
        calculateMianHeight() {
            this.mianH = window.innerHeight - 63;
        },
        async handleProcess() {
            const text = this.stripHtml(this.originalContent)
            if (!text.trim()) {
                this.$message.warning('请输入原文内容');
                return;
            }
            if (!this.formData.articleType) {
                this.$message.warning('请选择稿件类型');
                return;
            }
            if (!this.formData.version) {
                this.$message.warning('请选择消痕版本');
                return;
            }
            if (this.formData.intensity === null) {
                this.$message.warning('请选择改写强度');
                return;
            }
            this.processing = true;
            this.streamStatus = true;
            this.resultContent = '';
            this.streamText = '';
            this.markedStreamText = '';
            this.streamWaiting = false
            this.hasResult = false;
            this.compareData = null;
            this.compareLoading = false;
            this.isStop = false;
            this.streamIndex = 0;
            api.startReduce(this.submitParams).then((res) => {
                if (res.code == 200) {
                    this.logId = res.data;
                    this.getStreamContent(res.data);
                    this.$store.dispatch('user/getUserInfo')
                } else if(res.code == 601) {
                    this.$confirm('你的"降痕字符"额度不够，立即加购继续使用', '温馨提示', {
                        confirmButtonText: '去购买',
                        cancelButtonText: '取消',
                        type: 'warning'
                    })
                        .then(() => {
                            EventBus.$emit("openVip", 1);
                        })
                        .catch(() => {
                            this.$message({
                                type: 'info',
                                message: '已取消'
                            })
                        })
                         this.clearTimer();
                } else{
                    this.$message.error(res.msg || '消痕失败');
                    this.clearTimer();
                }
            }).catch((err) => {
                console.error(err);
                this.$message.error('请求失败，请稍后重试');
                this.clearTimer();
            });
        },
        // 轮询获取流式内容
        getStreamContent(id) {
            if (this.debounceTimer) clearTimeout(this.debounceTimer);
            this.debounceTimer = setTimeout(() => {
                api.getStreamContent(id, this.streamIndex).then((res) => {
                    if (res.code === 200) {
                        if (res.data && res.data.length !== 0) {
                            this.streamWaiting = false
                            this.streamIndex += res.data.length;
                            let combinedText = '';
                            res.data.forEach((item) => {
                                if (item !== '[DONE]') combinedText += item;
                            });
                            this.typeText(combinedText, () => {
                                if (res.data[res.data.length - 1] === '[DONE]') {
                                    this.streamIndex = 0;
                                    this.streamStatus = false;
                                    this.streamWaiting = false
                                    this.processing = false;
                                    this.compareLoading = true;
                                    this.$message.success('消痕完成');
                                    // 消痕完成后，获取对比数据
                                    this.getCompareData(this.logId);
                                    return;
                                }
                                if (!this.isStop) this.getStreamContent(id);
                            });
                        } else {
                            // 空数据表示后端仍在生成下一段，显示与提交时一致的居中加载并继续轮询
                            this.streamWaiting = true
                            if (!this.isStop) this.getStreamContent(id);
                        }
                    } else {
                        this.$message.warning(res.msg);
                        this.clearTimer();
                    }
                }).catch((err) => {
                    console.error(err);
                    this.clearTimer();
                });
            }, 500);
        },
        // 打字机效果
        typeText(text, callback) {
            let index = 0;
            if (this.typingTimer) clearInterval(this.typingTimer);
            this.typingTimer = setInterval(() => {
                if (index < text.length) {
                    this.streamText += text[index];
                    this.markedStreamText = marked(this.streamText);
                    this.scrollToBottom();
                    index++;
                } else {
                    clearInterval(this.typingTimer);
                    if (callback) callback();
                }
            }, 20);
        },
        scrollToBottom() {
            this.$nextTick(() => {
                const container = this.$refs.resultScroll;
                if (container) container.scrollTop = container.scrollHeight;
            });
        },
        clearTimer() {
            clearTimeout(this.debounceTimer);
            clearInterval(this.typingTimer);
            this.streamIndex = 0;
            this.streamStatus = false;
            this.streamWaiting = false
            this.processing = false;
            if (!this.hasResult) {
                this.streamText = '';
                this.markedStreamText = '';
            }
        },
        stopStream() {
            this.isStop = true;
            this.clearTimer();
            this.$message.info('已停止生成');
        },
        // 获取对比数据
        getCompareData(logId) {
            api.getReduceDetail({ logId: logId }).then((res) => {
                this.compareLoading = false;
                this.streamText = '';
                this.markedStreamText = '';
                if (res.code === 200 && res.data) {
                    // 接口返回 text（原文，#标记删除部分）和 result（结果，#标记新增部分）
                    const originalText = res.data.text || this.stripHtml(this.originalContent);
                    const resultText = res.data.result || '';
                    // 去掉 # 后的纯文本作为最终结果
                    this.resultContent = resultText.replace(/#/g, '');
                    this.compareData = {
                        originalSegments: this.parseMarkedText(originalText, 'delete'),
                        resultSegments: this.parseMarkedText(resultText, 'insert')
                    };
                    this.hasResult = true;
                } else {
                    this.resultContent = this.stripHtml(this.originalContent);
                    this.compareData = { originalSegments: [], resultSegments: [] };
                    this.hasResult = true;
                }
            }).catch((err) => {
                console.error('获取对比数据失败', err);
                this.compareLoading = false;
                this.streamText = '';
                this.markedStreamText = '';
                // 即使对比接口失败，也把流式结果作为最终结果
                this.resultContent = this.stripHtml(this.originalContent);
                this.compareData = { originalSegments: [], resultSegments: [] };
                this.hasResult = true;
            });
        },
        // 解析 # 标记的文本，返回 [{type, text}] 数组
        // # 成对出现，#...# 之间的内容为 markType 类型，其余为 equal
        parseMarkedText(text, markType) {
            if (!text) return [];
            const parts = text.split('#');
            const segments = [];
            for (let i = 0; i < parts.length; i++) {
                if (parts[i] === '') continue;
                segments.push({
                    type: i % 2 === 1 ? markType : 'equal',
                    text: parts[i]
                });
            }
            return segments;
        },
        // 原文 diff HTML（#标记的部分加红色删除线）
        compareOriginalHtml() {
            if (!this.compareData || !this.compareData.originalSegments) return '';
            return this.compareData.originalSegments.map(item => {
                if (item.type === 'equal') return this.escapeHtml(item.text);
                return `<span class="diff-del">${this.escapeHtml(item.text)}</span>`;
            }).join('');
        },
        // 结果 diff HTML（#标记的部分加绿色下划线）
        compareResultHtml() {
            if (!this.compareData || !this.compareData.resultSegments) return '';
            return this.compareData.resultSegments.map(item => {
                if (item.type === 'equal') return this.escapeHtml(item.text);
                return `<span class="diff-add">${this.escapeHtml(item.text)}</span>`;
            }).join('');
        },
        handleUpload() {
            this.$refs.fileInput.click();
        },
        onFileChange(e) {
            const file = e.target.files[0];
            if (!file) return;

            const fileName = file.name.toLowerCase();
            const ext = fileName.split('.').pop();

            if (ext === 'txt') {
               this.uploading = true;
                const reader = new FileReader();
                reader.onload = (ev) => {
                    let text = ev.target.result;
                    let msg = '导入成功';
                    if (text.length > 10000) {
                        text = text.substring(0, 10000);
                        msg = '导入成功，单次最多只能上传10000字符，已自动截取';
                    }
                    this.originalContent = text;
                    this.uploading = false;
                    this.$message.success(msg);
                };
                reader.onerror = () => {
                    this.uploading = false;
                    this.$message.error('文件读取失败');
                };
                reader.readAsText(file, 'UTF-8');
            } else if (ext === 'docx') {
                   this.uploading = true;
                const reader = new FileReader();
                reader.onload = (ev) => {
                    const arrayBuffer = ev.target.result;
                    mammoth.convertToHtml({ arrayBuffer: arrayBuffer })
                        .then(result => {
                            const html = result.value;
                            // docx 转 HTML 后是 <p> 标签，提取前先转成换行
                            const plain = this.htmlToText(html);
                            let text = plain;
                            let msg = '导入成功';
                            if (text.length > 10000) {
                                text = text.substring(0, 10000);
                                msg = '导入成功，单次最多只能上传10000字符，已自动截取';
                            }
                            this.originalContent = text;
                            this.uploading = false;
                            this.$message.success(msg);
                        })
                        .catch(err => {
                            this.uploading = false;
                            this.$message.error('docx解析失败：' + (err.message || '未知错误'));
                        });
                };
                reader.onerror = () => {
                    this.uploading = false;
                    this.$message.error('文件读取失败');
                };
                reader.readAsArrayBuffer(file);
            } else if (ext === 'doc') {
                this.$message.warning('.doc旧格式不支持，请另存为.docx后重新上传');
            } else {
                this.$message.warning('仅支持 txt / doc / docx 格式');
            }
            e.target.value = '';
        },
         // HTML 转纯文本，保留段落换行（用于 docx 导入）
        htmlToText(html) {
            if (!html) return '';
            // 先把 <br> 替换成换行
            let text = html.replace(/<br\s*\/?>/gi, '\n');
            // 块级标签替换成换行
            text = text.replace(/<\/(p|div|h[1-6]|li|tr)>/gi, '\n');
            // 去掉所有剩余 HTML 标签
            text = text.replace(/<[^>]+>/g, '');
            // 解码常见 HTML 实体
            text = text.replace(/&nbsp;/g, ' ')
                       .replace(/&amp;/g, '&')
                       .replace(/&lt;/g, '<')
                       .replace(/&gt;/g, '>')
                       .replace(/&quot;/g, '"')
                       .replace(/&#39;/g, "'");
            // 清理多余空行
            return text.replace(/\u200B/g, '').replace(/\n{3,}/g, '\n\n').trim();
        },
        handleClear() {
            this.$confirm('确认清空所有内容？', '提示', { type: 'warning' }).then(() => {
                this.originalContent = '';
                this.resultContent = '';
                this.streamText = '';
                this.markedStreamText = '';
                this.compareData = null;
                this.hasResult = false;
                this.compareLoading = false;
                this.logId = '';
                this.clearTimer();
            }).catch(() => {});
        },
        handleCopy() {
            const text = this.stripHtml(this.resultContent)
            if (!text) {
                this.$message.warning('暂无内容可复制');
                return;
            }
            navigator.clipboard.writeText(text).then(() => {
                this.$message.success('已复制到剪贴板');
            });
        },
        handleDownload(type) {
            const text = this.stripHtml(this.resultContent)
            if (!text) {
                this.$message.warning('暂无内容可下载');
                return;
            }
            const blob = new Blob([text], { type: type === 'txt' ? 'text/plain' : 'application/msword' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `消痕结果_${Date.now()}.${type === 'txt' ? 'txt' : 'doc'}`;
            a.click();
            URL.revokeObjectURL(url);
        },
        handleHistory() {
            this.$router.push('/reduceHistory')
        }
    }
}
</script>

<style lang="scss" scoped>
#novel_generator {
   width: 100%;
    height: 100vh;
    display: flex;
    flex-flow: column;
    overflow-y: hidden;   /* 原来是 overflow: hidden */
    overflow-x: auto;     /* 加这行 */
}

#novel_generator .mian {
    width: 100%;
    padding-top: 20px;
    box-sizing: border-box;
    flex: 1;
    min-height: 0;
    overflow-y: hidden;   /* 原来是 overflow: hidden */
    overflow-x: auto;     /* 加这行 */
}

.de-ai-rate {
    padding: 16px 24px 20px;
    background: #f5f7fa;
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    box-sizing: border-box;

    // ===== 顶部栏 =====
    .top-bar {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: 20px;
        margin-bottom: 14px;
        flex-shrink: 0;
    }

    .top-left {
        flex: 1;
        min-width: 0;
    }

    .title {
        font-size: 26px;
        font-weight: 700;
        color: #1a1a2e;
        margin: 0 0 10px 0;
    }

    // 选择器一排
    .selectors-inline {
        //display: flex;
       // align-items: center;
       // gap: 28px;
       // flex-wrap: wrap;
        padding: 10px 18px;
        background: #fff;
        border-radius: 10px;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
    }

    .selector-inline {
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        gap: 8px;
        flex-wrap: wrap;
        flex-shrink: 0;
    }

    .selector-label {
        font-size: 13px;
        font-weight: 600;
        color: #333;
        white-space: nowrap;
    }

    .chip {
        display: inline-block;
        padding: 8px 20px;
        font-size: 15px;
        color: #555;
        background: #f5f6fa;
        border: 1px solid transparent;
        border-radius: 6px;
        cursor: pointer;
        transition: all 0.2s;
        user-select: none;
        white-space: nowrap;

        &:hover {
            background: #eef1f8;
            color: #333;
        }

        &.active {
            background: linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%);
            color: #d4542a;
            border-color: #fcb69f;
            font-weight: 600;
        }
    }

    // 历史记录按钮
    .history-wrap {
        display: flex;
        height: 30px;
        background: #0089ff;
        align-items: center;
        cursor: pointer;
        color: #fff;
        border-radius: 8px;
        margin-left: 10px;
        padding: 3px 10px;
    }

    .history-btn {
        font-size: 13px;
        color: #666;

        &:hover {
            color: #4a8cff;
        }

        i {
            margin-right: 4px;
        }
    }

    // 主体内容
    .main-content {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 14px;
        flex: 1;
        min-height: 0;
    }

    .content-panel {
        background: #fff;
        border-radius: 10px;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
        display: flex;
        flex-direction: column;
        overflow: hidden;
        min-height: 0;
    }

    .panel-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 48px;
        padding: 0 12px;
        border-bottom: 1px solid #f0f0f0;
        font-size: 13px;
        font-weight: 600;
        color: #333;
        flex-shrink: 0;
    }

    .panel-header-left {
        display: flex;
        align-items: center;
        gap: 6px;
    }

    .panel-header-right {
        display: flex;
        align-items: center;
        gap: 8px;
    }

    .result-count {
        font-size: 12px;
        color: #999;
    }

    // Quill 编辑器区域
    .editor-area {
        flex: 1;
        min-height: 0;
        overflow: hidden;
        display: flex;
        position: relative;
    }

    .my-editor {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        color: #111111;
        padding: 0;
    }
}

// ===== diff 对比区域 =====
.diff-area {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    &.diff-left {
        background: #fef9f9;
    }

    &.diff-right {
        background: #f8fdf8;
    }
}

.diff-legend-bar {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 6px 14px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.04);
    flex-shrink: 0;
}

.legend-item {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    color: #888;
}

.legend-del {
    display: inline-block;
    width: 16px;
    height: 3px;
    background: #e8463a;
    border-radius: 2px;
}

.legend-add {
    display: inline-block;
    width: 16px;
    height: 3px;
    background: #1dc981;
    border-radius: 2px;
}

.diff-content {
    flex: 1;
    overflow-y: auto;
    padding: 10px 14px;
    font-size: 16px;
    line-height: 1.75;
    color: #333;
    white-space: pre-wrap;
    word-break: break-all;
}

// diff 标记样式
:deep(.diff-del) {
    color: #e8463a;
    text-decoration: line-through;
    background: rgba(232, 70, 58, 0.06);
    border-radius: 2px;
    padding: 0 1px;
}

:deep(.diff-add) {
    color: #1dc981;
    text-decoration: underline;
    text-decoration-color: #1dc981;
    background: rgba(29, 201, 129, 0.06);
    border-radius: 2px;
    padding: 0 1px;
}

// ===== 流式生成区域 =====
.stream-area {
    flex: 1;
    display: flex;
    flex-direction: column;
    position: relative;
    overflow: hidden;
}

.stream-loading {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 16px;
    background: #f0f5ff;
    border-radius: 20px;
    font-size: 13px;
    color: #4a8cff;
    z-index: 10;

    i {
        font-size: 16px;
    }
}

.stream-text {
    flex: 1;
    padding: 10px 14px;
    font-size: 16px;
    line-height: 1.75;
    color: #111111;
    overflow-y: auto;
    white-space: pre-wrap;
    word-break: break-all;
    background: #fff;

    p {
        margin-bottom: 4px;
    }
}

.stream-stop-btn {
    position: absolute;
    bottom: 12px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 6px 14px;
    background: #fff;
    border: 1px solid #e0e0e0;
    border-radius: 20px;
    font-size: 12px;
    color: #666;
    cursor: pointer;
    z-index: 10;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    transition: all 0.2s;

    &:hover {
        background: #f5f5f5;
        color: #333;
    }

    i {
        font-size: 14px;
    }
}

// ===== 对比加载中 =====
.compare-loading {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    color: #4a8cff;
    font-size: 13px;

    i {
        font-size: 20px;
    }
}

// ===== 空占位 =====
.empty-placeholder {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    color: #c0c4cc;
    font-size: 14px;

    i {
        font-size: 36px;
    }
}

// Quill 全局样式
:deep(.ql-container.ql-snow) {
    border: none;
    flex: 1;
    height: auto;
    overflow-y: auto;
    font-family: 'Consolas', 'Microsoft YaHei', 'Segoe UI', monospace;
}

:deep(.ql-editor) {
    padding: 10px 14px;
    font-size: 13px;
    line-height: 1.75;
    white-space: pre-wrap;
    word-break: break-all;
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
        display: none;
    }

    &.ql-blank::before {
        font-style: normal;
        text-transform: none;
        left: 14px;
        right: 14px;
        top: 10px;
        color: #c0c4cc;
        font-size: 13px;
        position: absolute;
    }

    a {
        color: #111111 !important;
        text-decoration: none;
    }

    p {
        font-size: 13px;
        color: #111111;
        margin-bottom: 4px;
    }
}

:deep(.ql-toolbar.ql-snow) {
    display: none;
}

:deep(.quill-editor) {
    flex: 1;
    display: flex;
    flex-direction: column;
    border: none !important;
    min-height: 0;
}

:deep(.quill-editor .ql-container) {
    border: none !important;
}

// 底部字数 / 开始按钮
.editor-footer {
    padding: 8px 12px;
    border-top: 1px solid #f0f0f0;
    font-size: 12px;
    color: #666;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-shrink: 0;
    gap: 10px;
}

.word-count b {
    color: #1a73e8;
    font-weight: 600;
}

.start-btn {
    background: linear-gradient(135deg, #4a8cff 0%, #2d6bff 100%);
    border: none;
    border-radius: 6px;
    padding: 0 16px;
    height: 32px;
    font-size: 13px;
    font-weight: 600;
    box-shadow: 0 2px 8px rgba(45, 107, 255, 0.25);
    white-space: nowrap;

    &:hover,
    &:focus {
        background: linear-gradient(135deg, #3a7cf2 0%, #255fe8 100%);
    }
}

// 结果操作栏
.result-actions {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    padding: 8px 12px;
    border-top: 1px solid #f0f0f0;
    background: #fafbfc;
    flex-shrink: 0;
    flex-wrap: wrap;
}

// =====================================================
//  响应式断点 1：大屏平板（≤ 1280px）
// =====================================================
@media (max-width: 1280px) {
    .de-ai-rate {
        padding: 12px 20px 16px;

        .title {
            font-size: 22px;
            margin-bottom: 8px;
        }

        .selectors-inline {
            gap: 20px;
            padding: 8px 14px;
        }

        .top-bar {
            margin-bottom: 12px;
        }
    }
}

// =====================================================
//  响应式断点 2：小屏平板（≤ 1024px）
// =====================================================
@media (max-width: 1024px) {
    .de-ai-rate {
        padding: 10px 16px 14px;
        overflow-y: auto;

        .top-bar {
            flex-direction: column;
            gap: 10px;
            margin-bottom: 10px;
        }

        .top-left {
            width: 100%;
        }

        .title {
            font-size: 20px;
            margin-bottom: 6px;
        }

        .selectors-inline {
            gap: 20px;
            padding: 8px 12px;
            flex-wrap: nowrap;
            overflow-x: auto;
            -webkit-overflow-scrolling: touch;

            &::-webkit-scrollbar {
                height: 4px;
            }
            &::-webkit-scrollbar-track {
                background: transparent;
            }
            &::-webkit-scrollbar-thumb {
                background: #d0d0d0;
                border-radius: 2px;
            }
        }

        .selector-inline {
            flex-shrink: 0;
        }

        .history-wrap {
            padding-top: 0;
            justify-content: flex-end;
        }

        .main-content {
            gap: 10px;
        }

        .editor-footer {
            padding: 6px 10px;
        }

        .start-btn {
            height: 30px;
            padding: 0 14px;
            font-size: 12px;
        }
    }
}

// =====================================================
//  响应式断点 3：平板竖屏 / 小屏（≤ 768px）
// =====================================================
@media (max-width: 768px) {
    #novel_generator .mian {
        padding-top: 10px;
        overflow-y: auto;
    }

    .de-ai-rate {
        padding: 8px 12px 12px;
        height: auto;
        min-height: 100%;

        .top-bar {
            gap: 8px;
            margin-bottom: 8px;
        }

        .title {
            font-size: 18px;
            margin-bottom: 6px;
        }

        .selectors-inline {
            gap: 16px;
            padding: 8px 10px;
            flex-wrap: nowrap;
            overflow-x: auto;
            -webkit-overflow-scrolling: touch;

            &::-webkit-scrollbar {
                height: 4px;
            }
            &::-webkit-scrollbar-thumb {
                background: #ccc;
                border-radius: 2px;
            }
        }

        .selector-inline {
            gap: 6px;
            flex-shrink: 0;
        }

        .selector-label {
            font-size: 12px;
        }

        .chip {
            padding: 3px 10px;
            font-size: 12px;
            border-radius: 6px;
        }

        .history-wrap {
            padding-top: 0;
        }

        .main-content {
            grid-template-columns: 1fr;
            gap: 10px;
            flex: none;
        }

        .content-panel {
            min-height: 240px;
            border-radius: 8px;
        }

        .editor-area {
            min-height: 180px;
        }

        .panel-header {
            padding: 6px 10px;
            font-size: 12px;
        }

        .editor-footer {
            padding: 6px 10px;
            flex-wrap: wrap;
            gap: 6px;
        }

        .start-btn {
            height: 32px;
            padding: 0 14px;
            font-size: 12px;
        }

        .result-actions {
            padding: 6px 10px;
            gap: 6px;
        }

        :deep(.ql-editor) {
            padding: 8px 12px;
            font-size: 13px;
            line-height: 1.7;
        }
    }
}

// =====================================================
//  响应式断点 4：手机（≤ 480px）
// =====================================================
@media (max-width: 480px) {
    #novel_generator .mian {
        padding-top: 8px;
    }

    .de-ai-rate {
        padding: 6px 8px 10px;

        .top-bar {
            gap: 6px;
            margin-bottom: 6px;
        }

        .title {
            font-size: 16px;
            margin-bottom: 4px;
        }

        .selectors-inline {
            gap: 12px;
            padding: 6px 10px;
            flex-wrap: nowrap;
            overflow-x: auto;
            -webkit-overflow-scrolling: touch;

            &::-webkit-scrollbar {
                height: 3px;
            }
            &::-webkit-scrollbar-thumb {
                background: #bbb;
                border-radius: 2px;
            }
        }

        .selector-inline {
            gap: 6px;
            flex-shrink: 0;
        }

        .selector-label {
            font-size: 12px;
        }

        .chip {
            padding: 3px 10px;
            font-size: 12px;
        }

        .main-content {
            gap: 8px;
        }

        .content-panel {
            min-height: 200px;
        }

        .panel-header {
            padding: 6px 8px;
            font-size: 12px;

            .panel-header-right {
                gap: 4px;
            }
        }

        .editor-area {
            min-height: 150px;
        }

        .editor-footer {
            padding: 6px 8px;
            flex-direction: column;
            align-items: stretch;
            gap: 6px;
        }

        .word-count {
            text-align: center;
        }

        .start-btn {
            width: 100%;
            height: 36px;
            font-size: 13px;
        }

        .result-actions {
            padding: 6px 8px;
            justify-content: space-between;

            .el-button {
                flex: 1;
            }
        }

        :deep(.ql-editor) {
            padding: 8px 10px;
            font-size: 13px;
            line-height: 1.65;
        }
    }
}
// 纯文本输入框
    .text-input {
        flex: 1;
        width: 100%;
        height: 100%;
        border: none;
        outline: none;
        resize: none;
        padding: 10px 14px;
        font-size: 16px;
        line-height: 1.75;
        font-family: 'Consolas', 'Microsoft YaHei', 'Segoe UI', monospace;
        color: #111111;
        background: #fff;
        white-space: pre-wrap;
        word-break: break-all;
        box-sizing: border-box;

        &::placeholder {
            color: #c0c4cc;
            font-size: 15px;
        }

        &::-webkit-scrollbar {
            width: 6px;
        }
        &::-webkit-scrollbar-track {
            background: transparent;
        }
        &::-webkit-scrollbar-thumb {
            background: #ddd;
            border-radius: 3px;
        }
    }
</style>
